import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux-sagas/store";

import "bootstrap/dist/css/bootstrap.css";
import "react-big-calendar-like-google/lib/css/react-big-calendar.css";
import "./index.css";
import "./custom.css";
import { BrowserRouter } from "react-router-dom";

// Translation feature
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { PreviousPathProvider } from "./context/PreviousPathProvider";

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    supportedLngs: ["en", "es"],
    // debug: true,
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
    lng: localStorage.getItem("lng") || "es",
  });

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
   <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PreviousPathProvider>
          <App />
        </PreviousPathProvider>
      </Provider>
    </BrowserRouter>
   </React.StrictMode>
);
